(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ao-cart"]) return;
  try {
    
(function(){
 if(window.__aoCartPromoApplyInstalled)return;
 window.__aoCartPromoApplyInstalled=true;
 document.addEventListener('click',function(event){
  const b=event.target.closest('[data-ao-cart-apply-code]');
  if(!b)return;
  const parent=b.closest('[data-ao-cart-coupon]');
  const field=parent?.querySelector('input');
  const status=parent?.querySelector('[data-ao-cart-coupon-error]');
  const code=(field?.value||'').trim().replace(/\s+/g,'').toUpperCase();
  if(!/^[A-Z0-9_-]{3,64}$/.test(code)){
    if(status)status.textContent='Bitte einen gültigen Rabattcode eingeben.';
    field?.focus();
    return;
  }
  const target=parent?.dataset.cartReturn||'/cart';
  window.location.assign('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(target));
 });
})();
if (!customElements.get('ao-cart-account')) {
  class AOCartAccount extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('a');
      const status = this.querySelector('[role="status"]');
      const form = this.closest('form');
      if (!link || !status || !form || !this.dataset.updateUrl) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      form.addEventListener('submit', (event) => {
        if (this.busy) event.preventDefault();
      }, options);
      form.addEventListener('click', (event) => {
        if (this.busy && event.target instanceof Element && event.target.closest('.ao-cart__remove')) event.preventDefault();
      }, options);
      link.addEventListener('click', async (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (this.busy) { event.preventDefault(); return; }
        const inputs = [...form.querySelectorAll('[name="updates[]"], [name="note"]')];
        if (!inputs.some((input) => input.value !== input.defaultValue)) return;
        event.preventDefault();
        if (!form.reportValidity()) return;
        const controls = [...inputs, ...form.querySelectorAll('button[type="submit"]')].map((control) => ({ control, disabled: control.disabled }));
        const removeLinks = [...form.querySelectorAll('.ao-cart__remove')].map((control) => ({ control, disabled: control.getAttribute('aria-disabled') }));
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        link.setAttribute('aria-disabled', 'true');
        status.textContent = this.dataset.savingMessage;
        try {
          const body = new FormData(form);
          controls.forEach(({ control }) => { control.disabled = true; });
          removeLinks.forEach(({ control }) => { control.setAttribute('aria-disabled', 'true'); });
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body,
            signal: AbortSignal.any([this.abort.signal, AbortSignal.timeout(15000)])
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error('Cart update failed');
          if (this.isConnected) window.location.assign(link.href);
        } catch (_) {
          if (this.isConnected) status.textContent = this.dataset.errorMessage;
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          link.removeAttribute('aria-disabled');
          controls.forEach(({ control, disabled }) => { control.disabled = disabled; });
          removeLinks.forEach(({ control, disabled }) => {
            if (disabled === null) control.removeAttribute('aria-disabled');
            else control.setAttribute('aria-disabled', disabled);
          });
        }
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('ao-cart-account', AOCartAccount);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-footer"]) return;
  try {
    
if (!customElements.get('ao-footer-localization')) {
  customElements.define('ao-footer-localization', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const form = this.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', () => {
        const returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-market-header"]) return;
  try {
    
if (!customElements.get('ao-header-language')) {
  customElements.define('ao-header-language', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const form = this.querySelector('form');
      const select = this.querySelector('select[name="language_code"]');
      if (!form || !select) return;
      form.addEventListener('submit', () => {
        const returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      }, { signal: this.controller.signal });
      select.addEventListener('change', () => form.requestSubmit(), { signal: this.controller.signal });
      this.classList.add('is-ready');
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.classList.remove('is-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-product"]) return;
  try {
    
  function initAOProducts(scope = document) {
    scope.querySelectorAll('[data-ao-product]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const showMedia = (id) => {
        if (!id || !root.querySelector(`[data-media-panel="${id}"]`)) return;
        root.querySelectorAll('[data-media-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.mediaPanel !== id;
          if (panel.hidden) panel.querySelectorAll('video').forEach((video) => video.pause());
        });
        root.querySelectorAll('[data-media-target]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
      };
      root.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
      const select = root.querySelector('[data-variant-select]');
      if (!select) return;
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        const shipping = root.querySelector('[data-product-shipping]');
        if (shipping) shipping.hidden = option.dataset.requiresShipping !== 'true';
        root.querySelector('[data-product-price]').textContent = option.dataset.price;
        const compare = root.querySelector('[data-product-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        const add = root.querySelector('[data-add-to-cart]');
        add.disabled = !available;
        add.textContent = available ? add.dataset.labelAvailable : add.dataset.labelSoldOut;
        root.querySelector('[data-product-availability]').textContent = available ? root.dataset.availableLabel : add.dataset.labelSoldOut;
        root.querySelector('[data-product-dynamic]').hidden = !available;
        const quantity = root.querySelector('[data-product-quantity]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        showMedia(option.dataset.media);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      });
    });
  }
  initAOProducts();
  document.addEventListener('shopify:section:load', (event) => initAOProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-release-list"]) return;
  try {
    
function aoInitializeMarketReleaseCatalogue(){
  const search=document.getElementById('AOListReleaseSearch');
  const year=document.getElementById('AOListReleaseYear');
  const tools=document.querySelector('[data-ao-list-release-tools]');
  const count=document.querySelector('[data-ao-list-release-count]');
  const empty=document.querySelector('[data-ao-list-release-empty]');
  const reset=document.querySelector('[data-ao-list-release-reset]');
  if(!search||!year||!tools||!count||!empty||!reset)return;
  aoInitializeMarketReleaseCatalogue.controller?.abort();
  const controller=new AbortController();
  aoInitializeMarketReleaseCatalogue.controller=controller;
  const options={signal:controller.signal};
  const groups=[...document.querySelectorAll('.ao-release-list[data-ao-release-section]')];
  const cards=groups.flatMap(group=>[...group.querySelectorAll('[data-ao-release]')]);
  const more=groups.flatMap(group=>[...group.querySelectorAll('[data-ao-release-more]')]);
  const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().replace(/ß/g,'ss');
  const records=cards.map(card=>({card,title:normalize(card.dataset.title||''),year:card.dataset.year||''}));
  const selectedYear=year.value;
  [...year.options].slice(1).forEach(option=>option.remove());
  [...new Set(records.map(record=>record.year).filter(Boolean))].sort().reverse().forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;year.appendChild(option)});
  year.value=selectedYear;
  if(!search.dataset.queryInitialized){
    const query=new URLSearchParams(window.location.search).get('q');
    if(query)search.value=query;
    search.dataset.queryInitialized='true';
  }
  function update(){
    const terms=normalize(search.value.trim()).split(/\s+/).filter(Boolean);
    const filtering=terms.length>0||Boolean(year.value);
    const matching=records.filter(record=>terms.every(term=>record.title.includes(term))&&(!year.value||record.year===year.value));
    const visible=new Set(matching.map(record=>record.card));
    cards.forEach(card=>{card.hidden=!visible.has(card)});
    count.textContent=count.dataset.template.replace('__VISIBLE__',matching.length).replace('__TOTAL__',records.length);
    empty.hidden=matching.length!==0;
    reset.hidden=!filtering;
    groups.forEach(group=>{group.hidden=!group.querySelector('[data-ao-release]:not([hidden])')&&!group.querySelector('[data-ao-list-release-tools]')});
  }
  more.forEach(button=>{button.hidden=true});
  tools.hidden=false;
  search.addEventListener('input',update,options);
  year.addEventListener('change',update,options);
  reset.addEventListener('click',()=>{
    search.value='';year.value='';update();search.focus();
  },options);
  update();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',aoInitializeMarketReleaseCatalogue);else aoInitializeMarketReleaseCatalogue();
document.addEventListener('shopify:section:load',aoInitializeMarketReleaseCatalogue);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-releases"]) return;
  try {
    
function aoInitializeReleaseCatalogue(){
  const search=document.getElementById('AOReleaseSearch');
  const year=document.getElementById('AOReleaseYear');
  const count=document.querySelector('[data-ao-release-count]');
  const empty=document.querySelector('[data-ao-release-empty]');
  if(!search||!year||!count||!empty)return;
  aoInitializeReleaseCatalogue.controller?.abort();
  const controller=new AbortController();
  aoInitializeReleaseCatalogue.controller=controller;
  const options={signal:controller.signal};
  const cards=[...document.querySelectorAll('[data-ao-release]')];
  const groups=[...document.querySelectorAll('[data-ao-release-section]')];
  const more=document.querySelector('[data-ao-release-more]');
  const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase();
  const records=cards.map(card=>({card,title:normalize(card.dataset.title||''),year:card.dataset.year||''}));
  const selectedYear=year.value;
  [...year.options].slice(1).forEach(option=>option.remove());
  [...new Set(records.map(record=>record.year).filter(Boolean))].sort().reverse().forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;year.appendChild(option)});
  year.value=selectedYear;
  let limit=16;
  function update(){
    const term=normalize(search.value.trim());
    const matching=records.filter(record=>record.title.includes(term)&&(!year.value||record.year===year.value));
    const visible=new Set(matching.slice(0,limit).map(record=>record.card));
    cards.forEach(card=>{card.hidden=!visible.has(card)});
    count.textContent=count.dataset.template.replace('__VISIBLE__',Math.min(limit,matching.length)).replace('__TOTAL__',matching.length);
    empty.hidden=matching.length!==0;
    if(more)more.hidden=matching.length<=limit;
    groups.forEach(group=>{group.hidden=!group.querySelector('[data-ao-release]:not([hidden])')&&!group.querySelector('[data-ao-release-tools]')&&!group.querySelector('[data-ao-release-more]:not([hidden])')});
  }
  document.querySelector('[data-ao-release-tools]').hidden=false;
  search.addEventListener('input',()=>{limit=16;update()},options);
  year.addEventListener('change',()=>{limit=16;update()},options);
  more?.addEventListener('click',()=>{
    const previouslyVisible=new Set(cards.filter(card=>!card.hidden));
    limit+=16;
    update();
    const firstNewCard=cards.find(card=>!card.hidden&&!previouslyVisible.has(card));
    if(!firstNewCard)return;
    const focusTarget=firstNewCard.querySelector('a[href],button:not([disabled]),[tabindex="0"]')||firstNewCard;
    if(focusTarget===firstNewCard)firstNewCard.setAttribute('tabindex','-1');
    focusTarget.focus();
  },options);
  update();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',aoInitializeReleaseCatalogue);else aoInitializeReleaseCatalogue();
document.addEventListener('shopify:section:load',aoInitializeReleaseCatalogue);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-videos"]) return;
  try {
    
(() => {
  const activePlayers = new WeakMap();
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const close = event.target.closest('[data-ao-video-close]');
    if (close) {
      const screen = close.closest('.ao-film')?.querySelector('.ao-film-screen');
      const state = screen && activePlayers.get(screen);
      if (!state) return;
      screen.replaceChildren(...state.nodes);
      state.button.setAttribute('aria-expanded', 'false');
      close.hidden = true;
      activePlayers.delete(screen);
      state.button.focus();
      return;
    }
    const button = event.target.closest('[data-ao-video]');
    if (!button) return;
    const id = button.dataset.aoVideo;
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    const screen = button.closest('.ao-film-screen');
    const closeButton = button.closest('.ao-film')?.querySelector('[data-ao-video-close]');
    if (!screen || !closeButton || activePlayers.has(screen)) return;
    const frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0';
    frame.title = button.dataset.title;
    frame.allow = 'encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.tabIndex = 0;
    activePlayers.set(screen, { nodes: [...screen.childNodes], button });
    button.setAttribute('aria-expanded', 'true');
    screen.replaceChildren(frame);
    closeButton.hidden = false;
    frame.focus();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
